import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('expenseSubmissionComments', app)
  return store
}
